export interface AuthParams {
  seckey: string | null
  redirectTo: string | null
  list: number | null
  loginType: number | null
}

export const getAuthParams = (url: string): AuthParams => {
  const usp = new URLSearchParams(url)
  const l = usp.get('l')
  const lt = usp.get('lt')

  return {
    seckey: usp.get('sc'),
    redirectTo: usp.get('r'),
    list: l !== null ? Number.parseInt(l) : null,
    loginType: lt !== null ? Number.parseInt(lt) : null,
  }
}
